import { useState, useEffect, useCallback } from 'react'
import { homepageService } from '../services/api'
import type { HomepageData } from '../types'

interface UseHomepageResult {
  data: HomepageData | null
  loading: boolean
  error: Error | null
  refresh: () => void
}

export function useHomepage(): UseHomepageResult {
  const [data, setData] = useState<HomepageData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await homepageService.getData()
      setData(response.data)
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to load homepage data'))
      console.error('Failed to fetch homepage data:', err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { data, loading, error, refresh: fetchData }
}
